import React from "react";
import { ExternalLink, MessageSquare } from "lucide-react";

const FEEDBACK_URL = "https://docs.google.com/forms/d/e/1FAIpQLSd6NNSi4soAldOjnBDcecbZsc_vGzP4TfgxwY-k_88sLLbh6g/viewform?usp=publish-editor";

export default function Feedback() {
  return (
    <div className="px-4 sm:px-8 py-8 max-w-3xl mx-auto" data-testid="feedback-page">
      <span className="label-eyebrow">Feedback</span>
      <div className="border border-zinc-200 bg-white rounded-sm p-6 mt-3">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-sm bg-amber-100 text-zinc-950 flex items-center justify-center shrink-0">
            <MessageSquare size={20} />
          </div>
          <div className="min-w-0">
            <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">
              Help improve Builders Binder
            </h1>
            <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
              Share what is working, what feels slow, or what would make tracking jobs easier for your team.
            </p>
            <a
              href={FEEDBACK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-zinc-950 text-white px-4 py-2.5 rounded-sm text-sm font-semibold hover:bg-zinc-800 mt-5"
              data-testid="feedback-form-link"
            >
              Open feedback form <ExternalLink size={15} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
